import InviteUsers from './InviteUsersWrapper'

export default InviteUsers
